import styled from "styled-components";

export const AccountStyle = styled.div`
  .heading-icon {
    color: #f28809;
  }

  .btn-row {
    justify-content: space-between;
    width: 60%;
    align-self: center;
  }
`;
